"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuantityInputView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const Wrap = app_1.styled.div `
  display: flex;
  height: 2.25rem;
`;
const ActionButton = (0, app_1.styled)(ui_1.Button) `
  ${(theme) => theme.flexCenter};
  border: 1px solid ${(theme) => theme.stroke};
  border-left-width: ${(_t, { $hideBorderLeft }) => $hideBorderLeft ? '0px' : '1px'};
  border-right-width: ${(_t, { $hideBorderRight }) => $hideBorderRight ? '0px' : '1px'};
  width: 3rem;
  max-height: 100%;
  padding: 0.25rem;
  min-width: unset;
  background: transparent;
  border-radius: 0px;
  margin-left: ${(_, { $marginLeft }) => ($marginLeft ? '-1px' : 0)};
  color: inherit;
  transition: all 0.3s;
  &:hover {
    filter: unset;
    > svg {
      opacity: 0.5;
    }
  }
  ${app_1.styled.disabled `
    opacity: 1;
    > svg {
      opacity: 0.1;
    }
  `}
`;
const StyledInput = (0, app_1.styled)(ui_1.NumberInput) `
  width: 100%;
  height: 100%;
  padding: 0 ${(theme) => theme.spacing.small};
  border-right-width: 0;
  background: transparent;
  user-select: none;
  /* pointer-events: auto; */
  :focus {
    outline: none;
  }
`;
function QuantityInputView({ value, increase, decrease, handleRemove, handleBlur, max, overstock, }) {
    return ((0, jsx_runtime_1.jsxs)(Wrap, { children: [(0, jsx_runtime_1.jsx)(ActionButton, Object.assign({ onClick: handleRemove, "$hideBorderRight": true }, { children: "X" })), (0, jsx_runtime_1.jsx)(StyledInput, { containerCss: (0, app_1.css) `
          > div {
            height: 100%;
          }
        `, max: max, min: 1, onBlur: handleBlur, defaultValue: value, name: "quantity" }), (0, jsx_runtime_1.jsx)(ActionButton, Object.assign({ onClick: decrease, "$marginLeft": true, "$hideBorderLeft": true, disabled: value === 1 }, { children: (0, jsx_runtime_1.jsx)(svg_1.SvgMinus, {}) })), (0, jsx_runtime_1.jsx)(ActionButton, Object.assign({ onClick: increase, "$marginLeft": true, disabled: value === max || overstock }, { children: (0, jsx_runtime_1.jsx)(svg_1.SvgPlus, {}) }))] }));
}
exports.QuantityInputView = QuantityInputView;
